import React from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { AppState } from 'services/types';
import { createStructuredSelector } from 'reselect';

import { ProductId } from 'services/products/types';
import {
    SprayProduct,
    SprayEntityIds,
    SprayApplicationRate,
    SprayEquipmentSetId,
    SprayProductUnits,
    SprayProductPerUnitType
} from 'services/sprayEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectProductFieldValue } from 'services/products/selectors';
import FieldValue from 'components/FieldValue';
import { isApplicationTypeNeedHalfCalculation } from 'services/sprayEvents/utils';
import SummaryProductTypeListItem from '../SummaryProductTypeListItem';
import SummaryProductNameListItem from '../SummaryProductNameListItem';
import SummaryProductReEntryPeriodListItem from '../SummaryProductReEntryPeriodListItem';
import SummaryProductWithholdingPeriodListItem from '../SummaryProductWithholdingPeriodListItem';
import SummaryProductOrderIntoTankListItem from '../SummaryProductOrderIntoTankListItem';
import SummaryProductTotalListItem from '../SummaryProductTotalListItem';
import SummaryProductRatePerTankListItem from '../SummaryProductRatePerTankListItem';
import SummaryProductRatePerHundredLitreListItem from '../SummaryProductRatePerHundredLitreListItem';
import SummaryProductRateListItem from '../SummaryProductRateListItem';

export interface OwnProps {
    productId: ProductId;
    orderIntoTank: number;
    product: SprayProduct;
    entityIds: SprayEntityIds;
    applicationRate: SprayApplicationRate;
    equipmentSetId: SprayEquipmentSetId;
    units: SprayProductUnits;
    perUnitType: SprayProductPerUnitType;
}

interface ConnectedProps {
    unitTypeId: UnitTypeId;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductsListComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            productId,
            orderIntoTank,
            entityIds,
            product,
            unitTypeId,
            applicationRate,
            equipmentSetId,
            units,
            perUnitType
        } = this.props;

        return (
            <FieldValue name="applicationType">
                {(applicationType: string): React.ReactElement => {
                    const needHalfCalculation =
                        isApplicationTypeNeedHalfCalculation(applicationType);

                    return (
                        <Grid className="summary-list-item">
                            <Grid.Row>
                                <Grid.Column className="summary-list-item-title">
                                    Spray product #{orderIntoTank}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductTypeListItem
                                        productId={productId}
                                    />
                                </Grid.Column>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductNameListItem
                                        productId={productId}
                                    />
                                </Grid.Column>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductOrderIntoTankListItem
                                        orderIntoTank={orderIntoTank}
                                    />
                                </Grid.Column>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductReEntryPeriodListItem
                                        productId={productId}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductWithholdingPeriodListItem
                                        productId={productId}
                                    />
                                </Grid.Column>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductTotalListItem
                                        unitTypeId={unitTypeId}
                                        product={product}
                                        productId={productId}
                                        entityIds={entityIds}
                                        applicationRate={applicationRate}
                                        needHalfCalculation={
                                            needHalfCalculation
                                        }
                                    />
                                </Grid.Column>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductRateListItem
                                        unitTypeId={unitTypeId}
                                        units={units}
                                        perUnitType={perUnitType}
                                    />
                                </Grid.Column>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductRatePerTankListItem
                                        equipmentSetId={equipmentSetId}
                                        product={product}
                                        productId={productId}
                                        unitTypeId={unitTypeId}
                                        applicationRate={applicationRate}
                                        needHalfCalculation={
                                            needHalfCalculation
                                        }
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryProductRatePerHundredLitreListItem
                                        equipmentSetId={equipmentSetId}
                                        product={product}
                                        productId={productId}
                                        unitTypeId={unitTypeId}
                                        applicationRate={applicationRate}
                                        needHalfCalculation={
                                            needHalfCalculation
                                        }
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    );
                }}
            </FieldValue>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    unitTypeId: makeSelectProductFieldValue('unitTypeId')
});

export default connect(mapStateToProps)(SummaryProductsListComponent);
